module.exports = __webpack_public_path__ + "img/expand.50b6f2d3.svg";